<template>
  <FlotoDropdownPicker
    v-if="(!disabled && !onlyText) || usePicker"
    :value="value"
    :multiple="multiple"
    :options="timezoneOptions"
    as-input
    immediate-search
    searchable
    :placeholder="placeholder"
    @change="handleChange"
    @selected="$emit('selected', $event)"
  />
  <span v-else class="text-ellipsis">
    {{ (selectedItem || {}).text }}
  </span>
</template>
<script>
import { TimezoneComputed } from '@state/modules/timezone'

export default {
  name: 'FlotoTimeZonePicker',
  model: {
    event: 'change',
  },
  props: {
    value: { type: [Array, String], default: undefined },
    multiple: { type: Boolean, default: false },
    usePicker: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    onlyText: { type: Boolean, default: false },
    placeholder: { type: String, default: undefined },
  },
  computed: {
    ...TimezoneComputed,
    selectedItem() {
      if (this.value) {
        return this.timezoneOptions.find((t) => t.key === this.value)
      }
      return {}
    },
  },
  methods: {
    handleChange(value) {
      if (value === undefined || value === '') {
        this.$emit('change', undefined)
      }
      this.$emit('change', value)
    },
  },
}
</script>
